var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['form__agreement', _vm.modify]},[_c('CheckboxComponent',{attrs:{"type":"checkbox","icon":true,"name":"agreement","text":`Подтверждаю своё согласие на
            <a
                class="link"
                href="${_vm.agreementLink ? _vm.agreementLink : "#" }"
                target="_blank">обработку персональных данных</a>`,"checked":_vm.checked},on:{"checkboxChanged":_vm._agreementChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }